/** Marker the server returns when there is no usable speech. */
const INAUDIBLE = '[inaudible]';

/**
 * Merge a transcript into whatever text the field already holds.
 *
 * APPEND, never replace — same rule as the native / server voice-note path.
 */
export function appendTranscript(existing: string, transcript: string): string {
  const clean = (transcript || '').trim();
  const before = typeof existing === 'string' ? existing.trim() : '';
  if (!clean || clean === INAUDIBLE) return before;
  if (!before) return clean;
  if (before === clean || before.endsWith(clean)) return before;
  return `${before}\n\n${clean}`;
}

export function pickRecorderMime(): string {
  if (typeof MediaRecorder === 'undefined') return '';
  const candidates = [
    'audio/mp4',
    'audio/webm;codecs=opus',
    'audio/webm',
    'audio/ogg;codecs=opus',
  ];
  return candidates.find((type) => MediaRecorder.isTypeSupported(type)) || '';
}

export function canRecordAudio(): boolean {
  return typeof navigator !== 'undefined'
    && !!navigator.mediaDevices?.getUserMedia
    && !!pickRecorderMime();
}
